export const BREAKPOINTS = Object.freeze({
  MOBILE: 375,
  TABLET: 768,
  DESKTOP: 1024,
  WIDE: 1040,
  FULL_HD: 1920,
});
